export default __webpack_public_path__ + "static/media/vertical-stripes.aa1f227f.webp";